import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RedefinirSenhaService } from '../../services/redefinir-senha.service';
import { parseBackendResponse } from '../../services/api-response.util';

@Component({
  selector: 'app-redefinir-senha',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./redefinir-senha.component.scss']
})
export class RedefinirSenhaComponent implements OnInit {
  redefinirSenhaForm!: FormGroup;
  token: string = '';
  enviando: boolean = false;
  mensagemLoading: string = 'Redefinindo...';

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private redefinirSenhaService: RedefinirSenhaService
  ) {}

  ngOnInit() {
    // Pega o token da URL (token JWT completo)
    this.route.queryParams.subscribe(params => {
      this.token = params['token'] || '';
      console.log('Token capturado da URL:', this.token ? this.token.substring(0, 50) + '...' : 'vazio');
    });

    this.redefinirSenhaForm = this.fb.group({
      senha: ['', [Validators.required, Validators.minLength(8)]],
      confirmarSenha: ['', [Validators.required]]
    }, { validators: this.senhasIguais });
  }

  mostrarSenha = false;
  mostrarConfirmar = false;

  toggleSenha() {
    this.mostrarSenha = !this.mostrarSenha;
  }

  toggleConfirmar() {
    this.mostrarConfirmar = !this.mostrarConfirmar;
  }

  senhasIguais(control: AbstractControl): ValidationErrors | null {
    const senha = control.get('senha');
    const confirmarSenha = control.get('confirmarSenha');
    
    if (senha && confirmarSenha && senha.value !== confirmarSenha.value) {
      return { senhasNaoCoincidem: true };
    }
    return null;
  }

  redefinirSenha() {
    if (this.redefinirSenhaForm.invalid) {
      this.redefinirSenhaForm.markAllAsTouched();
      this.toastr.warning('Por favor, verifique os campos destacados.', 'Formulário Inválido');
      return;
    }

    if (!this.token) {
      this.toastr.error('Token inválido ou ausente.', 'Erro');
      return;
    }

    if (this.enviando) {
      return;
    }

    this.enviando = true;
    this.mensagemLoading = 'Redefinindo...';
    const senha = this.redefinirSenhaForm.get('senha')?.value;
    const tempoInicio = Date.now();
    const tempoMinimo = 3000; // 3 segundos

    // O backend valida o token JWT completo, então sempre envia o token completo
    console.log('Token capturado da URL (completo):', this.token);
    console.log('Enviando para o backend:', { Token: this.token.substring(0, 50) + '...', NovaSenha: '***' });

    // Após 1 segundo, muda a mensagem para "Salvando..."
    setTimeout(() => {
      if (this.enviando) {
        this.mensagemLoading = 'Salvando...';
      }
    }, 1000);

    this.redefinirSenhaService.redefinirSenha(this.token, senha).subscribe({
      next: (response) => {
        const tempoDecorrido = Date.now() - tempoInicio;
        const tempoRestante = Math.max(0, tempoMinimo - tempoDecorrido);

        setTimeout(() => {
          this.enviando = false;
          const parsed = parseBackendResponse(response, 200);
          const mensagem = parsed.mensagem || 'Senha alterada com sucesso!';
          this.toastr.success(mensagem, 'Sucesso');
          this.router.navigate(['/login']);
        }, tempoRestante);
      },
      error: (err) => {
        console.error('Erro completo na redefinição de senha:', err);
        console.error('Status HTTP:', err.status);
        console.error('Erro body:', err.error);
        
        const tempoDecorrido = Date.now() - tempoInicio;
        const tempoRestante = Math.max(0, tempoMinimo - tempoDecorrido);

        setTimeout(() => {
          this.enviando = false;
          const parsed = parseBackendResponse(err?.error, err?.status);
          let errorMsg = parsed.mensagem || 'Ocorreu um erro ao redefinir a senha.';
          
          this.toastr.error(errorMsg, 'Erro ao Redefinir Senha');
        }, tempoRestante);
      }
    });
  }
}

